<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
  <v-data-table
          no-data-text="Нет ингредиентов"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="modifierHeaders"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :items="product.modifiers"
          :loading="loading"
          loading-text="Загрузка ингредиентов... Подождите пожалуйста"
  >
    <template v-slot:body="props">
      <draggable
          :list="props.items"
          @end="endDrag(props.items)"
          tag="tbody"
      >
        <tr
            v-for="(item, index) in props.items"
            :key="index"
        >
          <td>
            <v-img v-if="item.modifier.image" :src="item.modifier.image.url" :width="40" :height="32"></v-img>
          </td>
          <td> {{ item.modifier.category.name }} </td>
          <td> {{ item.modifier.name }} </td>
          <td>
            <v-simple-checkbox @click="toggleRequired(item)" v-model="item.required"></v-simple-checkbox>
          </td>
          <td>
            <v-simple-checkbox @click="toggleIsAdditional(item)" v-model="item.is_additional"></v-simple-checkbox>
          </td>
          <td>
                  <div class="text-right">
                    <v-menu offset-y left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                                small
                                class="mr-2"
                                v-bind="attrs"
                                v-on="on"
                        >
                          mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item @click="submitDialog = true; submitItem = item">
                          <v-list-item-title>Удалить</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
          </td>
        </tr>
      </draggable>
    </template>
  </v-data-table>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>
          <v-btn
                  @click="deleteItem(submitItem); submitDialog = false">
            Да
          </v-btn>

          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import ProductService from "../api/ProductService";
  import ModifierService from "../api/ModifierService";
  import draggable  from 'vuedraggable'

  export default {
    name: 'ProductModifiersTable',
    props: {
        value: Object,
        loading: Boolean,
    },
    components: { draggable },
    methods: {
      endDrag(items){
        ProductService.updateProductModifiersSort(this.product.id, items).then(response => {
          this.productCategories = response.data
        })
      },
      deleteItem(item){
        let _this = this;
        ProductService.removeModifierRelation(item.id).then(response => {
          _this.product.modifiers.splice(_this.product.modifiers.indexOf(_this.product.modifiers.find(modifier => modifier.id == item.id)) , 1)
        });
      },
      toggleRequired(item){
        ProductService.updateModifierRelation(this.product.id, item.id, {
          required: item.required ? 1 : 0
        })
      },
      toggleIsAdditional(item){
        ProductService.updateModifierRelation(this.product.id, item.id, {
          is_additional: item.is_additional ? 1 : 0
        })
      },
    },
    watch: {
      product(val) {
        this.$emit('input', val);
      },
    },
    data() {
      return {
        product: this.value,
        submitDialog: false,
        submitItem: null,
        modifierHeaders: [
          {
            text: 'Изображение',
            value: 'modifier.image',
            sortable: false
          },
          {
            text: 'Категория',
            value: 'modifier.category.name',
          },
          {
            text: 'Ингредиент',
            value: 'modifier.name',
          },
          {
            text: 'Нельзя удалить',
            value: 'required',
            sortable: false
          },
          {
            text: 'Аллерген',
            value: 'is_additional',
            sortable: false
          },
          {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
        ],
      };
    },
  }
</script>
